import { RatePlanCharge } from '../ratePlan/makeRatePlanCapacities';
import getCurrentTimezoneDate from './getCurrentTimezoneDate';
import isRatePlanChargeOutdated from './isRatePlanChargeOutdated';

export type RatePlanWithDiscount = Pick<
  RatePlanCharge,
  'model' | 'discountPercentage' | 'discountAmount' | 'effectiveEndDate'
>;

export const hasRatePlanActiveDiscounts = (
  ratePlanCharges: Array<RatePlanWithDiscount>,
  ratePlanTimeZone: string,
) => {
  const currentRatePlanDate = getCurrentTimezoneDate(ratePlanTimeZone);
  return ratePlanCharges.some(
    (ratePlanCharge) =>
      isDiscount(ratePlanCharge) &&
      ((ratePlanCharge.discountAmount ?? 0) > 0 || (ratePlanCharge.discountPercentage ?? 0) > 0) &&
      !isRatePlanChargeOutdated(ratePlanCharge, currentRatePlanDate),
  );
};

const isDiscount = (ratePlanCharge: RatePlanWithDiscount) =>
  ratePlanCharge.model.toLowerCase().includes('discount');
